import * as actions from './teamCategory/actions'
import * as mutations from './teamCategory/mutations'
import * as getters from './teamCategory/getters'

import { dataProps } from './teamCategory/properties'

const state = {
    list: [],
    nav: {
        page_number: 0,
        limit: 50,
        total: 0
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/teamCategory.js